class KlaviyoInit extends HTMLElement {
  constructor() {
    super();
    this.timeout = 10000;
    this.interval = 500;
    this.klaviyoSelector = '[data-klaviyo-form]';
    this.defaultFormSelector = '.default-form';
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const klaviyoForm = this.querySelector(this.klaviyoSelector);
    const defaultForm = this.querySelector(this.defaultFormSelector);

    if (!klaviyoForm || !defaultForm) {
      return;
    }

    defaultForm.style.display = 'block';
    klaviyoForm.style.display = 'none';

    let elapsedTime = 0;

    const checkInterval = setInterval(() => {
      elapsedTime += this.interval;

      if (klaviyoForm.children.length > 0) {
        clearInterval(checkInterval);
        defaultForm.style.display = 'none';
        klaviyoForm.style.display = 'block';
      }

      if (elapsedTime >= this.timeout) {
        clearInterval(checkInterval);
      }
    }, this.interval);
  }
}

customElements.define('klaviyo-init', KlaviyoInit);
